import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import EMTable from '../Tables/EMTable';
import { auxActions } from '../../actions/auxActions';

import {
  Paper,
  Modal,
  CircularProgress,
  withStyles,
} from '@material-ui/core';

import translate from '../../locales';
import { APP_CLAIMS, pageModes, styleWithCommonClasses } from '../../_constants/emparkConstants';
import TitleToolbar from '../Forms/TitleToolbar';
import CellTable from '../Tables/CellTable';
import ErrorMessage from '../ErrorMessage';
import Unauthorized from '../Unauthorized';

const __t = translate;

const styles = styleWithCommonClasses({
  errorText: {
    marginTop: '20px'
  }
});

class HoursPage extends React.Component {
  constructor(props) {
    super(props);

    this.handleSaveHours = this.handleSaveHours.bind(this);
  }

  componentDidMount() {
    this.props.changeMode(pageModes.list);
    this.props.fetchHours();
  }

  render() {
    const { hours, loading } = this.props;

    const rowsHoursTable = [
      { id: 'val', align: 'center', disablePadding: false, label: __t('value') },
    ];

    if (this.props.mode === pageModes.list)
      return (
        <div className={this.props.classes.root} style={{ height: '100vh' }}>
          <Unauthorized claim={APP_CLAIMS.MENU_AUX_V}>
            <Modal className={this.props.classes.loadingFixedCenter} open={loading}>
              <CircularProgress color="secondary" />
            </Modal>
            <Paper
              className={this.props.classes.paper}
              elevation={0}
            >
              <EMTable
                tableTitle={__t('hours')}
                dataSource={hours}
                rows={rowsHoursTable}
                onTableEdit={() => this.props.changeMode(pageModes.edit)}
              />
            </Paper>
          </Unauthorized>
        </div>
      )

    return (
      <div className={this.props.classes.root}>
        <Modal className={this.props.classes.loadingFixedCenter} open={loading}>
          <CircularProgress color="secondary" />
        </Modal>
        <Paper
          className={this.props.classes.paper}
          elevation={0}
        >
          <TitleToolbar
            title={__t('hours')}
            onSave={this.handleSaveHours}
            onCancel={() => this.props.changeMode(pageModes.list)}
          >
            <CellTable
              refReturnData={(returnData) => { this.tableSubmit = returnData }}
              values={hours.map(d => d.val.toString())}
              type="number"
            />
            <ErrorMessage
              className={this.props.classes.errorText}
              error={this.props.error}
            />
          </TitleToolbar>
        </Paper>
      </div>
    )
  }

  /* events */
  handleSaveHours() {
    const values = this.tableSubmit();

    let hours = values
      .filter(v => v != '')
      .map((v, i) => ({
        id: i,
        val: Number(v)
      }));

    if (hours.length === 0) {
      this.props.setError(__t("error_no_values"))
      return;
    }

    hours.sort((a, b) => a.val - b.val);

    this.props.sendHours(hours);
  }
}

function mapStateToProps(state) {
  return {
    hours: state.auxReducer.hours,
    loading: state.auxReducer.loading,
    mode: state.auxReducer.mode,
    error: state.auxReducer.error
  }
}

function mapDispatchToProps(dispatch) {
  return {
    changeMode: (mode) => {
      dispatch(auxActions.changeMode(mode));
    },
    fetchHours: () => {
      dispatch(auxActions.fetchHours());
    },
    sendHours: (hours) => {
      dispatch(auxActions.sendHours(hours))
    },
    setError: (error) => {
      dispatch(auxActions.setError(error))
    }
  }
}

HoursPage.propTypes = {
  hours: PropTypes.array,
  loading: PropTypes.bool,
  mode: PropTypes.string,
  error: PropTypes.string,
  changeMode: PropTypes.func,
  fetchHours: PropTypes.func,
  sendHours: PropTypes.func,
  setError: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(HoursPage));